import { PaymentRequestGetApprovalsAdapter } from '../../../adapter';

export default async function PaymentRequestGetApprovalsUseCase(event) {
    const requestUrl =
        'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/payment-request/approvals/get';

    const payload = {
        data: {
            paymentRequestData: {
                ...event
            },
            signature: ''
        }
    };

    const result = await PaymentRequestGetApprovalsAdapter(requestUrl, JSON.stringify(payload));
    return result;
}
